module.exports = __webpack_public_path__ + "img/footer-gzh.c95d4b59.png";